export const CONSTANT = {
  userSessionExpired: 'userSessionExpired',
  userLogin: 'userLogin',
  userLogout: 'userLogout',
  userLoginWithBiometric: 'userLoginWithBiometric',
};

export const storageKeys = {
  MOBILE_DATA_KEY: 'MobileData',
  IS_SESSION_EXPIRED: 'isSessionExpired',
  IS_FLUTTER_WEB_VIEW: 'isFlutterWebView',
};
